import React from "react";
import { connect } from "react-redux";

import EquipmentItem from "./AlienEquipmentItem";

import { getEquipment, getMoreEquipment } from '../../actions/equipmentActions';

class AlienEquipment extends React.Component {
    componentWillMount() {
        const { dispatch, id } = this.props;

        dispatch(getEquipment({
            params: {user_id: id}
        }));
    }

    getMoreRecords(url) {
        if(!url) return false;
        
        const { dispatch, id } = this.props;

        dispatch(getMoreEquipment({
            url: url,
            params: {user_id: id}
        }));
    }

    render() {
        
        const { equipments } = this.props;
        const { isFetching, isFetchingMore } = equipments;
        const { results } = equipments.data;
        const moreOrders = equipments.data.next || null;

        return (
            <div className="menu-content-equipment menu-content-item screen-bottom-block">
                <div className="rounded-white-block">
                    <div className="white-block-top search-top-panel header-tabs tab-nav">
                        <h3>Список оборудования</h3>
                    </div>
                    <div className="white-block-content">
                        <ul className="items-list">
                            {
                                isFetching ?
                                <li className="list-item" >Загружается...</li>
                                :
                                    results.length ?
                                    results.map((elem, index) => {
                                        return (
                                            <EquipmentItem
                                                key={index}
                                                id={elem.id}
                                                title={elem.title}
                                                width={elem.width}
                                                height={elem.height}
                                                user={elem.user}
                                                cam_type={elem.cam_type}
                                                image={elem.image}
                                            />
                                        );
                                    })
                                    : <li className="list-item" >Оборудований нет</li>
                            }
                        </ul>
                        <div className="tab-content tab-content2 hidden">
                        </div>
                    </div>
                </div>
                {
                    moreOrders && !isFetching ?
                    <div className="big-button without-shadow button-action" style={{height:"auto", textAlign:"center",marginTop:"30px",marginBottom:"30px"}}>
                        <button
                            className={isFetchingMore ? 'disabled' : ''}
                            onClick={() => this.getMoreRecords(moreOrders)}>{isFetchingMore ? 'Загружается...' : 'Загрузить еще'}</button>
                    </div>
                    : ''
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(AlienEquipment);


// WEBPACK FOOTER //
// ./src/components/Profile/AlienEquipment.js